// extracted by mini-css-extract-plugin
export var icon = "Icon-module--icon--0CT-6";